<template>
  <div v-if="timeslot_collection_list" class="timeslot-collection-multi-drag-list">
    <el-alert v-if="get_tsc_selected" class="mt-4" title="Info" type="info" show-icon>
      You selected a timeslot collection.
      <!-- <span :style="{color: selected_timeslot_collection.color, fontWeight: 'bold'}">{{selected_timeslot_collection.name}}</span>. -->
      If you create a new event in the calendar now it will be assigned to it.
    </el-alert>

    <!--
    <el-alert v-if="get_effort_selected" class="mt-4" title="Info" type="info" show-icon>
      You selected an effort.
      If you create a new session in the calendar now it will be assigned to this effort.
    </el-alert>
    -->

    <div v-if="mode === 'weekdaypref'" class="clearfix my-2">
      <!-- <el-checkbox size="small" v-model="show_active_range">Show validity scope</el-checkbox> -->
      <el-checkbox size="small" v-model="show_active_items" style="float: left" class="mr-2"></el-checkbox>
      <div class="font-size: small;">
        Show only active rules between
        {{calendar_view_settings.visible_range.from_date|shortDate}}
        and
        {{calendar_view_settings.visible_range.to_date|shortDate}}
      </div>
    </div>

    <draggable
      :style="{ display: mode === 'commitment' ? 'flex' : 'block' }"
      v-model="draggablesList"
      :swapThreshold="0.25"
      draggable=".timeslot-collection-draggable">
      <div
        class="timeslot-collection-draggable"
        v-for="timeslot_collection in draggablesList"
        v-if="!timeslot_collection.deleted"
        :key="timeslot_collection.$id"
        :id="timeslot_collection.$id">
        <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        <template v-if="timeslot_collection.type === 'TSC'">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <div style="display: flex; align-items: center">
              <div>
                <el-color-picker
                  :value="timeslot_collection.color"
                  @update="onSetColor($event, timeslot_collection.$id)"
                  @change="onSetColor($event, timeslot_collection.$id)"
                  :predefine="predefineColors"
                ></el-color-picker>
              </div>
              <div style="margin-left: 0.5em">
                  <inline-editable-text
                    @change="onSetCollectionName($event, timeslot_collection.$id)"
                    :id="timeslot_collection.$id"
                    :value="timeslot_collection.name"
                    :inline="true"
                    :reset-on-update="false"
                    :reset-on-cancel="false"
                    :lost-focus-is-update="false"
                  />
              </div>
            </div>
            <div class="d-flex">
              <template v-if="mode === 'weekdaypref'">
                <font-awesome-icon
                  v-show="get_tsc_selected === timeslot_collection.$id"
                  class="clickable"
                  icon="brush"
                  color="black"
                  size="lg"
                  @click="onSelectTimeslotCollection( timeslot_collection.$id )"
                />
                <font-awesome-icon
                  v-show="get_tsc_selected !== timeslot_collection.$id"
                  class="clickable"
                  icon="brush"
                  color="#BBBBBB"
                  size="lg"
                  @click="onSelectTimeslotCollection( timeslot_collection.$id )"
                />
              </template>
              <TimeslotCollectionPopover
                class="ml-2"
                @deleted="onTimeslotCollectionDeleted"
                :timeslot_collection="timeslot_collection"
                :timeslot_collection_id="timeslot_collection.$id" />
            </div>
          </div>

          <!-- TODO: progressbar instead -->
          <!--
          <div class="hourbox">
            <template v-if="mode === 'weekdaypref'">
              <span>
                {{ aggregated_hours_events[timeslot_collection.$id] }}
                of {{aggregated_hours_timeslots[timeslot_collection.$id]}}h
                ( {{ aggregated_hours_used_capacity_in_percent[timeslot_collection.$id]  }}% )
              </span>
            </template>
            <span v-if="has_conflict_list[timeslot_collection.$id] && has_conflict_list[timeslot_collection.$id].length > 0"
                  style="color:red; font-weight: bold;">!!!</span>
          </div>
          -->

          <template v-if="mode === 'commitment'">
            <!--
            <TimeslotCollectionPopover
              style="float:right"
              @deleted="onTimeslotCollectionDeleted"
              :timeslot_collection="timeslot_collection"
              :timeslot_collection_id="timeslot_collection.$id" />
              -->

            <TimeslotCollection
              class="mt-2"
              :timeslot_collection="timeslot_collection"
              :timeslot_collection_id="timeslot_collection.$id"
            />
          </template>
          <template v-if="mode === 'weekdaypref'">

            <TimeslotWeeklyPreferences
              :timeslot_collection_id="timeslot_collection.$id"
              :show-active-range="show_active_range"
              :show-inactive-items="!show_active_items"
            />
            <hr class="m-2">

            <TimeslotExceptions :timeslot_collection_id="timeslot_collection.$id"/>

          </template>
        </template>

        <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        <template v-else-if="timeslot_collection.type === 'BLOCKER'">
          <div
            class="colorbox mr-2"
            :style="{backgroundColor: 'gray', color: 'white'}"
            @click="onSelectTimeslotCollection( timeslot_collection.$id )">
            <!-- <i class="el-icon-circle-close-outline"></i> -->
            <template v-if="mode === 'weekdaypref'">
              <font-awesome-icon
                v-show="get_tsc_selected === timeslot_collection.$id"
                icon="brush"
                color="white"
              />
              <font-awesome-icon
                v-show="get_tsc_selected !== timeslot_collection.$id"
                icon="shield-alt"
                color="black"
              />
            </template>
          </div>
          <em>{{timeslot_collection.name}}</em>
          <!--
          <div class="hourbox">{{ aggregated_hours_events[timeslot_collection.$id] }} of {{aggregated_hours_timeslots[timeslot_collection.$id]}}h ( {{ aggregated_hours_used_capacity_in_percent[timeslot_collection.$id]  }}% )</div>
          -->

          <!--
          <TimeslotCollection
            :isBlockerTSC="true"
            @deleted="onTimeslotCollectionDeleted"
            :timeslot_collection="timeslot_collection"
            :timeslot_collection_id="timeslot_collection.$id" />
          -->
        </template>

        <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        <template v-else-if="timeslot_collection.type === 'GOOGLE'">
          <div
            class="colorbox mr-2"
            :style="{backgroundColor: 'var(--blue)'}"
            @click="onSelectTimeslotCollection( timeslot_collection.$id )">
            <template v-if="mode === 'weekdaypref'">
              <font-awesome-icon
                v-show="get_tsc_selected === timeslot_collection.$id"
                icon="brush"
                color="white"
              />
              <font-awesome-icon
                v-show="get_tsc_selected !== timeslot_collection.$id"
                :icon="['fab', 'google']"
                color="black"
              />
            </template>
          </div>
          <i>Google Calendar</i>
          <!--
          <div class="hourbox">
            <template v-if="mode === 'weekdaypref'">
              {{ aggregated_hours_events[timeslot_collection.$id] }} of {{aggregated_hours_timeslots[timeslot_collection.$id]}}h ( {{ aggregated_hours_used_capacity_in_percent[timeslot_collection.$id]  }}% )
            </template>
          </div>
          -->

          <!-- Content for Google Calendar goes here (TBD) -->
        </template>

        <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        <!--

        <template v-else-if="timeslot_collection.type === 'COMMITMENT'">
          <div class="colorbox" :style="{ backgroundColor: timeslot_collection.color}"></div>
          {{timeslot_collection.name}}
          [*]
          <div class="hourbox">{{ aggregated_hours_events[timeslot_collection.$id] }} of {{aggregated_hours_timeslots[timeslot_collection.$id]}}h ( {{ aggregated_hours_used_capacity_in_percent[timeslot_collection.$id]  }}% )
            <span v-if="has_conflict_list[timeslot_collection.$id].length > 0" style="color:red; font-weight: bold;">!!!</span>
          </div>

          <div style="padding: 8px 8px 8px 6px">
            <pre>
              {{timeslot_collection}}
              TODO: Figure out to which commitment this belongs
              TODO: Show 'parent' TSC
            </pre>
            <TimeslotCollection
              @deleted="onTimeslotCollectionDeleted"
              :timeslot_collection="timeslot_collection"
              :timeslot_collection_id="timeslot_collection.$id" />
          </div>
        </template>

        -->

        <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        <template v-else>
          <div slot="label">{{timeslot_collection.type}}</div>OH NO
        </template>
      </div>

      <UnassignedCommitmentList v-if="mode === 'commitment'"/>
    </draggable>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import TimeslotCollection from "./TimeslotCollection";
import TimeslotCollectionPopover from '@/components/Config/Timeslots/TimeslotCollectionPopover';
import TimeslotWeeklyPreferences from "@/components/Config/Timeslots/TimeslotWeeklyPreferences";
import UnassignedCommitmentList from "@/components/CalendarPage/Timeslots/UnassignedCommitmentList";
import Draggable from "vuedraggable";
import TimeslotExceptions from '@/components/Config/Timeslots/TimeslotExceptions'
import { COLOR_LIST as predefineColors } from "@/misc/colors";

export default {
  props: {
    mode: {
      default: "commitment",
    },
  },
  data() {
    return {
      is_saving: false,
      not_yet_saved_priorities: {},
      show_active_range: true,
      show_active_items: false,
      predefineColors: predefineColors,
    };
  },
  computed: {
    ...mapGetters("timeslots", [
      // "flattened_calendar_data_all",
    ]),
    ...mapGetters("calendar", ["user_timeline_events", "optimizer_timeline_events", "calendar_view_settings"]),
    ...mapGetters("calendar", ["get_tsc_selected", "get_effort_selected"]),
    timeslot_collection_list() {
      return this.$models.timeslotCollection.subscribeList().itemsSorted;
      // !!!! TODO SUCHE NACH return
      // return this.$models.timeslotCollection.subscribeList().itemsSorted
      // return this.$models.timeslotCollection.subscribeList().itemsSorted;
    },

    draggablesList: {
      get() {
        if (this.is_saving) {
          return this.timeslot_collection_list.clone().sort((a, b) => {
            let a_sortidx = this.not_yet_saved_priorities[a.$id] || 1e9;
            let b_sortidx = this.not_yet_saved_priorities[b.$id] || 1e9;
            if (a_sortidx < b_sortidx) return -1;
            if (a_sortidx > b_sortidx) return 1;
            return 0;
          });
        }
        return this.timeslot_collection_list;
      },
      set(items) {
        let sortidx = 1;
        this.not_yet_saved_priorities = {};
        let priorities = items.map(item => {
          this.not_yet_saved_priorities[item.$id] = sortidx;
          return { id: item.$id, sortidx: sortidx++ };
        });
        this.is_saving = true;
        this.$api.timeslot_collection_set_priorities({ priorities }).then(() => {
          this.is_saving = false;
        });
        // TODO: Fix flickering, by updating items directly
      },
    },

    /* TODO: MOVE TO GETTERS / MIXIN !!! */
    flattened_calendar_data_all() {
      // HACK
      let fake_data = {};
      this.timeslot_collection_list.forEach(tsc => {
        fake_data[tsc.$id] = { aggregated_hours: 0, conflicts: [] };
      });
      console.log("fake_data", fake_data);
      return fake_data;
    },

    aggregated_hours_timeslots() {
      let aggregated_hours_timeslots = [];
      let timeslot_collection_listLength = this.timeslot_collection_list.length;
      for (let i = 1; i < timeslot_collection_listLength; i++) {
        let timeslot_collection = this.timeslot_collection_list[i];
        let flattened_calendar_data = this.flattened_calendar_data_all[timeslot_collection.$id];
        aggregated_hours_timeslots[timeslot_collection.$id] = flattened_calendar_data.aggregated_hours;
      }

      // round hours
      Object.entries(aggregated_hours_timeslots).forEach(item => {
        aggregated_hours_timeslots[item[0]] = aggregated_hours_timeslots[item[0]].toFixed(1);
      });

      return aggregated_hours_timeslots;
    },

    aggregated_hours_events() {
      let aggregated_hours_events = [];

      let timeslot_collectionListLength = this.timeslot_collection_list.length;
      for (let i = 0; i < timeslot_collectionListLength; i++) {
        aggregated_hours_events[this.timeslot_collection_list[i].$id] = 0;
      }

      let nrEvents = this.user_timeline_events.length;
      for (let i = 0; i < nrEvents; i++) {
        let event = this.user_timeline_events[i];
        if (event.data.tscId !== null) {
          aggregated_hours_events[event.data.tscId] += event.end.diff(event.start, "minutes") / 60;
        }
      }

      let nrOptimizerEvents = this.optimizer_timeline_events.length;
      for (let i = 0; i < nrOptimizerEvents; i++) {
        let event = this.optimizer_timeline_events[i];
        aggregated_hours_events[event.data.tscId] += event.end.diff(event.start, "minutes") / 60;
      }

      // round hours
      Object.entries(aggregated_hours_events).forEach(item => {
        aggregated_hours_events[item[0]] = aggregated_hours_events[item[0]].toFixed(1);
      });
      return aggregated_hours_events;
    },

    aggregated_hours_used_capacity_in_percent() {
      let aggregated_hours_used_capacity_in_percent = [];

      Object.entries(this.aggregated_hours_events).forEach(item => {
        let TSCId = item[0];
        if (
          this.aggregated_hours_timeslots[TSCId] &&
          this.aggregated_hours_events[TSCId] &&
          this.aggregated_hours_timeslots[TSCId] > 0 &&
          !isNaN(this.aggregated_hours_timeslots[TSCId]) &&
          !isNaN(this.aggregated_hours_events[TSCId])
        ) {
          aggregated_hours_used_capacity_in_percent[TSCId] = (
            (this.aggregated_hours_events[TSCId] / this.aggregated_hours_timeslots[TSCId]) *
            100
          ).toFixed(0);
        } else {
          aggregated_hours_used_capacity_in_percent[TSCId] = 0;
        }
      });
      return aggregated_hours_used_capacity_in_percent;
    },

    has_conflict_list() {
      let has_conflict_list = [];
      let timeslot_collection_listLength = this.timeslot_collection_list.length;
      for (let i = 1; i < timeslot_collection_listLength; i++) {
        let timeslot_collection = this.timeslot_collection_list[i];
        let flattened_calendar_data = this.flattened_calendar_data_all[timeslot_collection.$id];
        has_conflict_list[timeslot_collection.$id] = flattened_calendar_data.conflicts;
      }
      return has_conflict_list;
    },
  },
  methods: {
    ...mapMutations("calendar", ["SET_ACTIVE_TIMESLOT_COLLECTION"]),

    // TODO: Move to mixin
    onSetCollectionName(newName, timeslot_collection_id) {
      console.log("Updating collection title to ", timeslot_collection_id, newName);
      this.$api.timeslot_collection_set_name({
        timeslotCollectionId: timeslot_collection_id,
        name: newName,
      });
    },

    onSetColor(color, timeslot_collection_id) {
      console.log("onSetColor", color);
      this.$api.timeslot_collection_set_color({
        timeslotCollectionId: timeslot_collection_id,
        color: color,
      });
    },

    onSelectTimeslotCollection(tsc_id) {
      if (this.get_tsc_selected === tsc_id) {
        this.SET_ACTIVE_TIMESLOT_COLLECTION(null);
      } else {
        this.SET_ACTIVE_TIMESLOT_COLLECTION(tsc_id || null);
      }
    },

    onTimeslotCollectionDeleted(tscId) {
      /* select tab that is not beeing deleted */
      // this.onTabSelect(null);
      this.SET_ACTIVE_TIMESLOT_COLLECTION(null);
    },
  },
  components: {
    UnassignedCommitmentList,
    TimeslotCollection,
    TimeslotCollectionPopover,
    TimeslotExceptions,
    TimeslotWeeklyPreferences,
    Draggable,
  },
};
</script>

<style>
/* Colorbox, Hourbox */
.timeslot-collection-multi-drag-list .colorbox {
  /* display: inline-block;
  width: 40px;
  height: 40px;
  border: 1px solid rgb(128, 128, 128);
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  border-radius: 3px; */
}
.timeslot-collection-multi-drag-list .colorbox:hover {
  /*border: 1px solid black;*/
}
.timeslot-collection-multi-drag-list .colorbox svg {
  width: 40px;
  height: 40px;
  padding: 10px;
}
.timeslot-collection-multi-drag-list .hourbox {
  /* display: inline-block;
  margin-left: 1em;
  position: absolute;
  left: 200px; */
  float: right;
}
.timeslot-collection-draggable {
  background-color: #f7f7f7;
  border: 1px solid #c5c5c5;
  margin: 0.25em 0;
  padding: 5px;
  border-radius: 3px;
  box-shadow: inset 0 4px 8px 0 #0000000d;
}
.timeslot-collection-draggable.sortable-ghost {
  border: 1px dashed #909399 !important;
  min-height: 10px;
}
.timeslot-collection-draggable.sortable-ghost > * {
  visibility: hidden !important;
}
</style>
